import { Box, Typography } from '@coolblue-development/becky';
import { EmailContactData } from '../../../../../models/EmailContact';
import CopyContactIdButton from '../CopyContactIdButton/CopyContactIdButton';
import { formatReceivedAt } from '../../../../../utils/emailContactHelpers';
import { Paperclip } from '@coolblue-development/icons';

interface EmailHeaderExpandedProps {
  data: EmailContactData;
}

const EmailHeaderExpanded = ({ data }: EmailHeaderExpandedProps): JSX.Element => {
  const { customerName, from, contactId, receivedAt, to, cc } = data;
  return (
    <div data-testid="email-header-expanded">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
          {customerName && (
            <Typography variant="h6" data-testid="email-customer-name">
              {customerName}
            </Typography>
          )}

          {from && (
            <Typography variant="subtitle2" color="textSecondary" data-testid="email-from">
              {'<'}
              {from}
              {'>'}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>
          {data.hasAttachments && <Paperclip color="#868A90" />}
          <CopyContactIdButton contactId={contactId} />

          {receivedAt && (
            <Typography variant="subtitle2" data-testid="email-received-at">
              {formatReceivedAt(receivedAt)}
            </Typography>
          )}
        </Box>
      </Box>

      {((to && to.length > 0) || (cc && cc.length > 0)) && (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
          {to && to.length > 0 && (
            <Typography variant="subtitle2" color="textSecondary" data-testid="email-to">
              To: {to.join(', ')}
            </Typography>
          )}

          {cc && cc.length > 0 && (
            <Typography variant="subtitle2" color="textSecondary" data-testid="email-cc">
              Cc: {cc.join(', ')}
            </Typography>
          )}
        </Box>
      )}
    </div>
  );
};

export default EmailHeaderExpanded;
